import { useGraphQLQuery } from '@betterment/js-runtime';
import { Card, Heading, Separator } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';

import { AccountRow } from './components/AccountRow';
import { PerformanceAccountsDocument } from './graphql/performanceAccounts.generated';

export const AccountsCard: React.FC = () => {
  const { data } = useGraphQLQuery(PerformanceAccountsDocument, { throwOnError: true });

  if (!data) return <CardLoader />;

  const {
    performance: { accounts },
  } = data;

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <Heading as="h2" variant="title200">
          Accounts
        </Heading>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content>
        {accounts.map(a => (
          <AccountRow key={a.id} account={a} />
        ))}
      </Card.Content>
    </Card>
  );
};
